import React from 'react'

import { useBulkTableStyles } from './styles'

export interface BulkTableColumn<TRow extends { storeId: string; storeName: string }> {
  headerLabel: string
  headerControl?: React.ReactNode
  renderCell: (row: TRow, rowIndex: number) => React.ReactNode
}

interface BulkTableProps<TRow extends { storeId: string; storeName: string }> {
  columns: BulkTableColumn<TRow>[]
  compact?: boolean
  rows: TRow[]
  stickyHeader?: boolean
  tableStyle?: React.CSSProperties
}

const BulkTable = <TRow extends { storeId: string; storeName: string }>({
  columns,
  compact = false,
  rows,
  stickyHeader = false,
  tableStyle
}: BulkTableProps<TRow>) => {
  const classes = useBulkTableStyles()
  return (
    <div className={classes.tableWrapper}>
      <table className={`${classes.table} ${compact ? classes.compactTable : ''}`} style={tableStyle}>
        <thead className={stickyHeader ? classes.stickyHeader : undefined}>
          <tr>
            <th>Loja</th>
            {columns.map(column => (
              <th key={column.headerLabel}>
                {column.headerLabel}
                {column.headerControl}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.storeId}>
              <td className={classes.storeName}>{row.storeName}</td>
              {columns.map(column => (
                <td key={column.headerLabel}>{column.renderCell(row, rowIndex)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default BulkTable
